import { render, staticRenderFns } from "./requests-detail-process-request-intervention.vue?vue&type=template&id=5c6a387f&"
import script from "./requests-detail-process-request-intervention.vue?vue&type=script&lang=js&"
export * from "./requests-detail-process-request-intervention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports